// src/axios_helper/axiosInstance.js

import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:8000/api',
  baseURL: 'https://mahaveerjewellerspali.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export default axiosInstance;
